import i18n from '@/lang/i18n'
import en from 'vee-validate/dist/locale/en'
import es from 'vee-validate/dist/locale/es'
import pt from 'vee-validate/dist/locale/pt_PT'

export default {
    i18nRootKey: 'validations',
    i18n,
    locale: 'es',
    dictionary: {
        es,
        en,
        pt
    }
}
